// extracted by mini-css-extract-plugin
export default {"paidModel":"a_paidModel__uBv+T","renewButton":"a_renewButton__JknT5"};